import FactoringCompanyStatus from '@/common/FactoringCompanyStatus'
import FactoringCompanyRisks from '@/common/FactoringCompanyRisks'
import FactoringDocumentReviewStatus from '@/common/FactoringDocumentReviewStatus'
import RugGuaranteeToBluStatus from '@/common/RugGuaranteeToBluStatus'
import store from '@/store'

export default class Utils {
    static userHasPerm (permission) {
        if (store.getters.user.roleId === 1) { return true }
        permission = permission.replaceAll('-', '_')
        permission = permission.split(/(?=[A-Z])/).join('_').toLowerCase()
        permission = permission.replace(/_+/g, '_')
        let permissions = store.getters.user.permissions[process.env.VUE_APP_BLUAPP] || []
        let index = permissions.findIndex(perm => perm === permission)
        if (index >= 0) { return true }
        return false
    }

    static getMenu (menus, parent = 0) {
        const newMenu = []
        const menusPrincipales = menus.filter(m => m.parentId === 0)
        // const menusPrincipales = [...new Set(menus.map((o) => o.parentId))]

        for (let menu of menusPrincipales) {
            menu.selected = false
            let childs = menus.filter(item => item.parentId === menu.id)
            childs = childs.map(m => {
                m.selected = false
                return m
            })
            menu.childs = childs
            newMenu.push(menu)
        }
        return newMenu
    }

    static getOrderedPermissions (permissions) {
        const orderedPermissions = []
        const apps = [...new Set(permissions.map((item) => item.app))]

        for (let app of apps) {
            let appPermissions = permissions.filter(item => item.app === app).map(item => {
                item.active = false
                return item
            })
            orderedPermissions.push({
                app, permissions: appPermissions
            })
        }
        return orderedPermissions
    }

    static isObjectEmpty (obj) {
        if (obj === undefined || !obj) {
            return true
        }
        return Object.entries(obj).length === 0 && obj.constructor === Object
    }

    static getStatusInfo (statusId) {
        if (statusId === FactoringCompanyStatus.REJECTED) { return { name: 'RECHAZADA', color: 'red', statusId: statusId, icon: 'times' } }
        // if (statusId === FactoringCompanyStatus.REJECTED_FOR_SHELL_COMPANY) { return { name: 'RECHAZADA POR EMPRESA FANTASMA', color: 'red', statusId: statusId } }
        // if (statusId === FactoringCompanyStatus.REJECTED_FOR_PLD) { return { name: 'RECHAZADA POR PLD', color: 'red', statusId: statusId } }
        if (statusId === FactoringCompanyStatus.PENDING) { return { name: 'PENDIENTE', color: 'black', statusId: statusId, icon: 'wrench' } }
        if (statusId === FactoringCompanyStatus.APPROVED) { return { name: 'APROBADA', color: 'green', statusId: statusId, icon: 'check circle' } }
        // if (statusId === FactoringCompanyStatus.DISABLED) { return { name: 'DESHABILITADA', color: 'grey', statusId: statusId } }
        if (statusId === FactoringCompanyStatus.RESTRICTED) { return { name: 'RESTRINGIDA', color: 'orange', statusId: statusId, icon: 'exclamation triangle' } }
        return { name: statusId, color: 'black', statusId, icon: '' }
    }

    static getRiesgoInfo (riesgo) {
        if (riesgo === FactoringCompanyRisks.BAJO) { return { name: 'BAJO', color: 'green', riesgo, icon: 'circle' } }
        if (riesgo === FactoringCompanyRisks.MEDIO) { return { name: 'MEDIO', color: 'yellow', riesgo, icon: 'circle' } }
        if (riesgo === FactoringCompanyRisks.ALTO) { return { name: 'ALTO', color: 'red', riesgo, icon: 'circle' } }
        return { name: riesgo, color: 'black', riesgo, icon: '' }
    }

    static getReviewDocumentStatusInfo (statusId) {
        if (statusId === FactoringDocumentReviewStatus.PENDING) { return { name: 'PENDIENTE', color: 'black', statusId: statusId } }
        if (statusId === FactoringDocumentReviewStatus.APPROVED) { return { name: 'APROBADA', color: 'green', statusId: statusId } }
        if (statusId === FactoringDocumentReviewStatus.REJECTED) { return { name: 'RECHAZADA', color: 'red', statusId: statusId } }
        return { name: statusId, color: 'black', statusId, icon: '' }
    }

    static getRugGuaranteeTobluStatusInfo (statusId) {
        if (statusId === RugGuaranteeToBluStatus.PENDING) { return { name: 'PENDIENTE', color: 'black', statusId: statusId } }
        if (statusId === RugGuaranteeToBluStatus.INCLUDE) { return { name: 'RECHAZADA', color: 'red', statusId: statusId } }
        if (statusId === RugGuaranteeToBluStatus.IGNORE) { return { name: 'APROBADA', color: 'blue', statusId: statusId } }
        return { name: statusId, color: 'black', statusId }
    }

    static setLocalToken () {
        if (!process.env.VUE_APP_ACCESS_TOKENS_LOCAL) { return '' }
        let allowedTokens = process.env.VUE_APP_ACCESS_TOKENS_LOCAL.split(',')
        if (allowedTokens) { return 'Bearer ' + allowedTokens[0] }
        return ''
    }

    static setCreditsManagerToken () {
        if (!process.env.VUE_APP_CM2_TOKEN) { return '' }
        let allowedTokens = process.env.VUE_APP_CM2_TOKEN.split(',')
        if (allowedTokens) { return 'Bearer ' + allowedTokens[0] }
        return ''
    }

    static setRugToken () {
        if (!process.env.VUE_APP_RUG_TOKEN) { return '' }
        let allowedTokens = process.env.VUE_APP_RUG_TOKEN.split(',')
        if (allowedTokens) { return 'Bearer ' + allowedTokens[0] }
        return ''
    }

    static setClientsManagerToken () {
        if (!process.env.VUE_APP_CLIENTS_MANAGER_TOKEN) { return '' }
        let allowedTokens = process.env.VUE_APP_CLIENTS_MANAGER_TOKEN.split(',')
        if (allowedTokens) { return 'Bearer ' + allowedTokens[0] }
        return ''
    }

    static displayOptionName (obj, val, defaultValue = 'Indefinido') {
        if (!obj) { return }
        for (var [key, value] of Object.entries(obj)) {
            if (value === val) {
                return key.replaceAll('_', ' ')
            }
        }
        return defaultValue || '-'
    }

    static displayOptions (obj) {
        let options = []
        for (let [key, value] of Object.entries(obj)) {
            options.push({ text: key.replaceAll('_', ' '), value: value })
        }
        return options
    }

    static displayOptionsFromArray (arr, keyValue, keyText) {
        let options = []
        for (let item of arr) {
            options.push({ text: item[keyText].toUpperCase(), value: item[keyValue] })
        }
        return options
    }

    static displayOptionFromList (arr, value, key = 'text') {
        let option = arr.find(item => item.value === value)
        if (option) return option[key]
        return ''
    }

    static booleanValue (value = undefined) {
        if (value) {
            value = value.toString()
            const trueValues = ['true', '1', 'yes']
            if (trueValues.includes(value.toLowerCase())) return true
        }
        return false
    }
}
